import type { FileModel } from "#features/conversations/types/FileModel.ts";

// A file is "processing" while the server reports it as such — not yet retrievable, not yet failed.
// Shared by the id collector below and the flag decorator so the two never drift apart.
const isFileProcessing = (file: FileModel): boolean => file.availability === "Processing";

// Files still awaiting a terminal indexation result. These are the files to poll, and the ones that
// gate send.
export const getProcessingFileIds = (files: FileModel[]): string[] =>
    files.filter(isFileProcessing).map(file => file.id);

// This single flag drives both the "Processing" card treatment and the send-gate.
export const withProcessingFlag = (files: FileModel[]): FileModel[] =>
    files.map(file => ({
        ...file,
        isProcessing: isFileProcessing(file)
    }));
